import dayjs from 'dayjs'

import decryptJWT from '../utils/decryptJWT'
const getNumber = (data) => data?.replace(/\D/g, '')

export function formatArrayToString(array) {
  return array.join(',')
}

export function formatStringToNumberArray(string) {
  return string.split(',').map(Number)
}

export function formatStringToArray(string) {
  return string.split(',')
}

function formatDate(date, options = {}) {
  const {
    hasHour = false,
    isEndOfDay = false,
    asDate = false,
    format = null
  } = options

  let d = dayjs(date)

  if (isEndOfDay) {
    d = d.endOf('day')
  }

  const defaultFormat = hasHour ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'

  return asDate ? d.toDate() : d.format(format || defaultFormat)
}

export function formatDateToFilter(date) {
  return formatDate(date, { format: 'DD-MM-YYYY' })
}

export function formatDateToLabel(date) {
  return formatDate(date, { format: 'DD/MM/YYYY' })
}
export function formatDateToDatePicker(
  date,
  hasHour = false,
  isEndOfDay = false
) {
  return formatDate(date, { hasHour, isEndOfDay, asDate: true })
}
export function formatDateToGetFilter(
  date,
  hasHour = false,
  isEndOfDay = false
) {
  return formatDate(date, { hasHour, isEndOfDay })
}

export function formatPhone(phone) {
  return getNumber(phone)
}

export function formatCep(cep) {
  return getNumber(cep)
}

export function decrypt(keysToDecrypt) {
  const decryptedParams = keysToDecrypt.reduce((acc, key) => {
    acc[key] = decryptJWT(key)
    return acc
  }, {})
  return decryptedParams
}

export function formatBusca(busca, separadorLinha) {
  const buscaFormatada = busca.trim().replace(/\s{2,}/g, ' ')
  const separadores = {
    enter: '\\n',
    espaco: ' ',
    ',': ',',
    '|': '|'
  }

  const separador = separadores[separadorLinha]
  return separador ? buscaFormatada.replaceAll(separador, ';') : buscaFormatada
}
